import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { Quote, Star, Play, Pause, Volume2 } from 'lucide-react';
const testimonials = [{
  quote: 'Lo mandé a imprimir en la gráfica del barrio en papel ilustración. Me salió mejor que cualquier cosa que encontré en el mercado. El mate y el truco, no hay mejor combo.',
  author: 'Matías G.',
  location: 'Buenos Aires',
  rating: 4,
  image: 'https://cdn.magicpatterns.com/uploads/7xp4Xng8GuaR6bNxuQdmku/7837f403-8435-4ed0-96b6-51d80de7283d.png',
  timeAgo: 'Hace 3 días'
}, {
  quote: 'Se lo compré a mis hijos para que jueguen en casa. No pararon en toda la tarde. La cara de felicidad cuando vieron las cartas no tiene precio.',
  author: 'Carolina M.',
  location: 'Rosario',
  rating: 4.5,
  image: 'https://cdn.magicpatterns.com/uploads/a1NERkdM8oWQF5PtVRZMhM/194a4973-4def-4489-8d69-4317935e28bf.png',
  timeAgo: 'Hace 1 semana'
}, {
  quote: 'Pensé que iba a ser un diseño genérico. La calidad del archivo y el detalle en cada carta me sorprendió. Ya lo llevé al asado y fue un éxito total.',
  author: 'Rodrigo T.',
  location: 'Córdoba',
  rating: 5,
  image: 'https://cdn.magicpatterns.com/uploads/1oiV1JhSu6sJF5aG2JuYJM/28125b73-09ba-4926-9722-fb055c50d975.png',
  timeAgo: 'Hace 5 días'
}];
function AudioPlayer({
  src
}: {
  src: string;
}) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const audioRef = useRef<HTMLAudioElement>(null);
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    const setAudioData = () => {
      setDuration(audio.duration);
    };
    const setAudioTime = () => {
      setCurrentTime(audio.currentTime);
    };
    const handleEnded = () => {
      setIsPlaying(false);
      setCurrentTime(0);
    };
    audio.addEventListener('loadedmetadata', setAudioData);
    audio.addEventListener('timeupdate', setAudioTime);
    audio.addEventListener('ended', handleEnded);
    return () => {
      audio.removeEventListener('loadedmetadata', setAudioData);
      audio.removeEventListener('timeupdate', setAudioTime);
      audio.removeEventListener('ended', handleEnded);
    };
  }, []);
  const togglePlay = () => {
    if (isPlaying) {
      audioRef.current?.pause();
    } else {
      audioRef.current?.play();
    }
    setIsPlaying(!isPlaying);
  };
  const formatTime = (time: number) => {
    if (isNaN(time)) return '0:00';
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };
  const timeLeft = duration - currentTime;
  return <div className="bg-navy-900 border border-gold/30 rounded-xl p-4 flex items-center gap-4 mt-4" data-id="element-318">
      <audio ref={audioRef} src={src} preload="metadata" data-id="element-319" />
      <button onClick={togglePlay} className="w-12 h-12 rounded-full bg-gold flex items-center justify-center flex-shrink-0 hover:scale-105 transition-transform shadow-[0_0_15px_rgba(212,175,55,0.3)]" data-id="element-320">
        {isPlaying ? <Pause className="w-6 h-6 text-navy-900 fill-navy-900" data-id="element-321" /> : <Play className="w-6 h-6 text-navy-900 fill-navy-900 ml-1" data-id="element-322" />}
      </button>
      <div className="flex-1" data-id="element-323">
        <div className="flex justify-between items-center mb-2" data-id="element-324">
          <div className="flex items-center gap-2" data-id="element-325">
            <Volume2 className="w-4 h-4 text-gold" data-id="element-326" />
            <span className="text-white font-semibold text-sm" data-id="element-327">
              Nota de voz
            </span>
          </div>
          <span className="text-white/60 text-sm font-mono" data-id="element-328">
            -{formatTime(timeLeft)}
          </span>
        </div>
        {/* Progress bar */}
        <div className="w-full h-1.5 bg-white/10 rounded-full overflow-hidden" data-id="element-329">
          <div className="h-full bg-gold transition-all duration-100 ease-linear" style={{
          width: `${duration ? currentTime / duration * 100 : 0}%`
        }} data-id="element-330" />
        </div>
      </div>
    </div>;
}
export function Testimonials() {
  return <section className="py-10 px-4 bg-navy-900 relative" data-id="element-331">
      <div className="max-w-6xl mx-auto" data-id="element-332">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-4xl md:text-5xl font-bebas text-white text-center mb-10" data-id="element-333">
          Lo que dicen los que ya lo tienen
        </motion.h2>

        {/* Highlighted Audio Testimonial 1 - Claudio */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy-800 rounded-3xl border border-gold/20 overflow-hidden mb-6 max-w-4xl mx-auto shadow-2xl" data-id="element-334">
          <div className="flex flex-col md:flex-row" data-id="element-335">
            <div className="w-full md:w-2/5 aspect-square" data-id="element-336">
              <img src="https://cdn.magicpatterns.com/uploads/me2jYgDrYMgwgTDQvWaaNs/f257436d-990f-4d3e-8851-4a8258e79cf3.png" alt="Kiosco de Claudio" className="w-full h-full object-cover" data-id="element-337" />
            </div>
            <div className="w-full md:w-3/5 p-6 md:p-8 flex flex-col justify-center relative" data-id="element-338">
              <Quote className="w-12 h-12 text-white/5 absolute top-6 right-6" data-id="element-339" />

              <div className="flex gap-1 mb-4" data-id="element-340">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-gold fill-gold" data-id="element-341" />)}
              </div>

              <h3 className="text-2xl md:text-3xl font-bebas text-white mb-2 leading-tight" data-id="element-342">
                "Claudio R. Tiene su kiosco hace 12 años y las vendió en la
                primer semana después de adquirirlas"
              </h3>

              <p className="text-white/70 mb-6 text-sm" data-id="element-343">
                Escuchá su experiencia real vendiendo el Pack Scaloneta en su
                local:
              </p>

              <AudioPlayer src="https://cdn.magicpatterns.com/uploads/tGBxbbwU5cVvqy65DcHaeM/202605011414.mp4" data-id="element-344" />
            </div>
          </div>
        </motion.div>

        {/* Highlighted Audio Testimonial 2 - Mario */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-navy-800 rounded-3xl border border-gold/20 overflow-hidden mb-12 max-w-4xl mx-auto shadow-2xl" data-id="element-345">
          <div className="flex flex-col md:flex-row-reverse" data-id="element-346">
            <div className="w-full md:w-2/5 aspect-square" data-id="element-347">
              <img src="https://cdn.magicpatterns.com/uploads/38irdn6mdH2XfBHuvwYhWr/be955f70-90ad-44a9-a2fd-eb20c2005d07.png" alt="Kiosco de Mario" className="w-full h-full object-cover" data-id="element-348" />
            </div>
            <div className="w-full md:w-3/5 p-6 md:p-8 flex flex-col justify-center relative" data-id="element-349">
              <Quote className="w-12 h-12 text-white/5 absolute top-6 left-6" data-id="element-350" />

              <div className="flex gap-1 mb-4" data-id="element-351">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-gold fill-gold" data-id="element-352" />)}
              </div>

              <h3 className="text-2xl md:text-3xl font-bebas text-white mb-2 leading-tight" data-id="element-353">
                "Mario L. Esto se vende más que las figuritas"
              </h3>

              <p className="text-white/70 mb-6 text-sm" data-id="element-354">
                Escuchá su experiencia real vendiendo el Pack Scaloneta en su
                local:
              </p>

              <AudioPlayer src="https://cdn.magicpatterns.com/uploads/eF4Pk6b3F8YJcwG9eDgiHZ/202605011414%20(1).mp4" data-id="element-355" />
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-356">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.15
        }} className="bg-navy-800 rounded-2xl border border-white/5 overflow-hidden hover:border-gold/30 transition-colors" data-id="element-357">
              {/* User photo */}
              <div className="w-full overflow-hidden" data-id="element-358">
                <img src={t.image} alt={`Reseña de ${t.author}`} className="w-full h-auto object-cover" data-id="element-359" />
              </div>

              <div className="p-6 relative" data-id="element-360">
                <Quote className="w-7 h-7 text-white/5 absolute top-4 right-4" data-id="element-361" />

                {/* Stars */}
                <div className="flex gap-1 mb-3" data-id="element-362">
                  {[...Array(5)].map((_, index) => {
                const starValue = index + 1;
                if (starValue <= t.rating) {
                  return <Star key={index} className="w-4 h-4 text-gold fill-gold" data-id="element-363" />;
                } else if (starValue - 0.5 === t.rating) {
                  return <div key={index} className="relative w-4 h-4" data-id="element-364">
                          <Star className="w-4 h-4 text-gold absolute" data-id="element-365" />
                          <div className="absolute inset-0 overflow-hidden w-[50%]" data-id="element-366">
                            <Star className="w-4 h-4 text-gold fill-gold" data-id="element-367" />
                          </div>
                        </div>;
                }
                return <Star key={index} className="w-4 h-4 text-gold/30" data-id="element-368" />;
              })}
                </div>

                <p className="text-white/90 leading-relaxed mb-4 text-[15px]" data-id="element-369">
                  "{t.quote}"
                </p>

                <div className="flex items-center justify-between" data-id="element-370">
                  <div data-id="element-371">
                    <span className="text-white font-semibold text-sm" data-id="element-372">
                      {t.author}
                    </span>
                    <span className="text-white/40 mx-1.5" data-id="element-373">·</span>
                    <span className="text-white/50 text-sm" data-id="element-374">{t.location}</span>
                  </div>
                  <span className="text-white/30 text-xs" data-id="element-375">{t.timeAgo}</span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}